import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useCourse from '@/composables/useCourse'
  import { EditorModule } from '@/store/modules/editor'
  import CourseApi from '@/services/api/CourseApi'
  import { CourseModule } from '@/store/modules/course'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditOrDeleteCourseGroupModal',
  props: {
    courseGroupId: {
      type: String,
      required: true,
    },
    _courseGroupTitle: {
      type: String,
      default: '',
    },
    deleteCourseGroup: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const { course } = useCourse()
  const { translateString } = useI18n()
  const courseGroupTitle = ref(props._courseGroupTitle)
  const submittingRequest = ref(false)

  const editTitle = computed(() =>
    props.deleteCourseGroup ? translateString('courses.deleteCourseGroup') : translateString('courses.editCourseGroup'),
  )

  const disabledCTA = computed(
    () =>
      submittingRequest.value ||
      (props.deleteCourseGroup
        ? courseGroupModules.value.length > 0
        : courseGroupTitle.value.trim().length && props._courseGroupTitle === courseGroupTitle.value.trim()),
  )

  const courseGroupModules = computed(() => EditorModule.courseModules(course.value!.id, props.courseGroupId) || [])

  const editOrDeleteCourseGroup = () => {
    submittingRequest.value = true
    if (props.deleteCourseGroup) {
      CourseApi.deleteCourseGroup(props.courseGroupId)
        .then(() => {
          const courseGroupIndex = CourseModule.course?.courseGroups.findIndex((cG) => cG.id === props.courseGroupId)
          if (typeof courseGroupIndex === 'number' && courseGroupIndex > -1) {
            CourseModule.course!.courseGroups.splice(courseGroupIndex, 1)
            const firstCourseGroupId = CourseModule.course?.courseGroups[0].id
            if (firstCourseGroupId) {
              CourseModule.setCurrentCourseGroup(firstCourseGroupId)
            } else {
              CourseModule.setCurrentCourseGroup('')
            }
          }
          eventBus.$toasted.success(translateString('courses.deletedCourseGroupSuccessfully'))
        })
        .finally(() => {
          submittingRequest.value = false
          eventBus.$emit('close-modal')
        })
    } else {
      CourseApi.updateCourseGroup({
        name: courseGroupTitle.value,
        courseGroupId: props.courseGroupId,
      })
        .then(() => {
          const courseGroup = CourseModule.course?.courseGroups.find((cG) => cG.id === props.courseGroupId)
          if (courseGroup) courseGroup.name = courseGroupTitle.value
          eventBus.$toasted.success(translateString('courses.updatedCourseGroupSuccessfully'))
        })
        .finally(() => {
          submittingRequest.value = false
          eventBus.$emit('close-modal')
        })
    }
  }

return { __sfc: true,props, course, translateString, courseGroupTitle, submittingRequest, editTitle, disabledCTA, courseGroupModules, editOrDeleteCourseGroup, computed, ref, TextRenderer, KetchUpButton, LoadingSpinner, useCourse, EditorModule, CourseApi, CourseModule, eventBus, useI18n }
}

})